import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, Printer, MapPin } from 'lucide-react';
import { FaTiktok, FaInstagram, FaFacebookF, FaLinkedinIn } from 'react-icons/fa';

const Footer = ({ translations }) => {
  const t = translations?.footer ?? {};
  const h = translations?.header ?? {};

  return (
    <motion.footer
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="bg-fut-bg-dark text-fut-text-light py-10 border-t border-fut-border"
      role="contentinfo"
    >
      <div className="container mx-auto max-w-screen-xl px-6 text-center">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">

          {/* Contacto */}
          <div>
            <h3 className="text-xl font-display text-fut-primary mb-4 drop-shadow-lg">
              {t.contactUs}
            </h3>

            <p className="flex items-center justify-center mb-2 text-fut-text-light">
              <Mail size={20} className="mr-2 text-fut-secondary" />
              <a
                href="mailto:jose@sanjoseobrerollc.com"
                className="text-fut-text-light hover:text-fut-primary transition-colors duration-300"
              >
                jose@sanjoseobrerollc.com
              </a>
            </p>

            <p className="flex items-center justify-center mb-2 text-fut-text-light">
              <Phone size={20} className="mr-2 text-fut-secondary" />
              <a
                href="tel:+18884536026"
                className="hover:text-fut-primary transition-colors duration-300"
              >
                888-453-6026
              </a>
            </p>

            <p className="flex items-center justify-center mb-2 text-fut-text-light">
              <Printer size={20} className="mr-2 text-fut-secondary" />
              <a
                href="tel:+19254212798"
                className="hover:text-fut-primary transition-colors duration-300"
              >
                925-421-2798
              </a>
            </p>

            <p className="flex items-center justify-center text-fut-text-light">
              <MapPin size={20} className="mr-2 text-fut-secondary" />
              <a
                href="https://www.google.com/maps/search/?api=1&query=15437+Anacapa+Rd+Victorville+CA+92392"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-fut-primary transition-colors duration-300"
              >
                15437 Anacapa Rd Victorville CA 92392
              </a>
            </p>
          </div>

          {/* Enlaces rápidos */}
          <div>
            <h3 className="text-xl font-display text-fut-primary mb-4 drop-shadow-lg">
              {t.quickLinks}
            </h3>
            <ul>
              <li className="mb-2">
                <a href="/" className="hover:text-fut-primary transition-colors duration-300">
                  {h.home || 'Home'}
                </a>
              </li>
              <li className="mb-2">
                <a href="/about" className="hover:text-fut-primary transition-colors duration-300">
                  {h.aboutUs || (h.home === 'Inicio' ? 'Sobre nosotros' : 'About Us')}
                </a>
              </li>
              <li className="mb-2">
                <a href="/services" className="hover:text-fut-primary transition-colors duration-300">
                  {h.services || (h.home === 'Inicio' ? 'Servicios' : 'Services')}
                </a>
              </li>
              <li className="mb-2">
                <a href="/packages" className="hover:text-fut-primary transition-colors duration-300">
                  {h.home === 'Inicio' ? 'Paquetes' : 'Packages'}
                </a>
              </li>
              <li className="mb-2">
                <a href="/contact" className="hover:text-fut-primary transition-colors duration-300">
                  {h.contact || (h.home === 'Inicio' ? 'Contacto' : 'Contact')}
                </a>
              </li>
              <li className="mb-2">
                <a href="/policies" className="hover:text-fut-primary transition-colors duration-300">
                  {h.home === 'Inicio' ? 'Políticas' : 'Policies'}
                </a>
              </li>
            </ul>
          </div>

          {/* Redes sociales */}
          <div>
            <h3 className="text-xl font-display text-fut-primary mb-4 drop-shadow-lg">
              {t.followUs || 'Follow Us'}
            </h3>
            <div className="flex justify-center space-x-6">
              <a
                href="https://www.tiktok.com/@sjo_consulting"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
                className="hover:text-fut-primary transition-colors duration-300 transform hover:scale-110"
              >
                <FaTiktok size={28} />
              </a>
              <a
                href="https://www.instagram.com/sjo_prodigies_prestamos/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="hover:text-fut-primary transition-colors duration-300 transform hover:scale-110"
              >
                <FaInstagram size={28} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=100063591101499"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="hover:text-fut-primary transition-colors duration-300 transform hover:scale-110"
              >
                <FaFacebookF size={28} />
              </a>
              <a
                href="https://www.linkedin.com/in/sjo-prodigies-multiservicios-790530b3/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="hover:text-fut-primary transition-colors duration-300 transform hover:scale-110"
              >
                <FaLinkedinIn size={28} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-fut-border pt-8">
          <p className="text-fut-text-light">
            &copy; {new Date().getFullYear()} San Jose Obrero LLC. {t.allRightsReserved}
          </p>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
